module.exports = __webpack_public_path__ + "img/Poke_Toast.65c180c2.jpg";